import { types, cast } from "mobx-state-tree";
import { StorageModel } from "../storage/StorageModel";
import { endpoints } from "../api/ApiEndpoints";
import { OrganizationStatusResponse } from "../../api-models/response/organization/OrganizationDetailsResponse";

const OrganizationStatusesModel = types.model({
  organizationStatuses: types.array(types.frozen<OrganizationStatusResponse>()),
});

export const OrganizationStatusesStorageModel = types
  .compose(OrganizationStatusesModel, StorageModel)
  .named("OrganizationStatusesStorageModel")
  .actions((self) => {
    return {
      mapResponse(response: Array<OrganizationStatusResponse>) {
        self.organizationStatuses = cast(response);
      },
    };
  })
  .views((self) => ({
    get endpoint() {
      const endpoint = endpoints.get("organization_statuses");
      return endpoint;
    },
    get isLoading() {
      return !self.organizationStatuses?.length;
    },
  }));
